import { IConfig } from '@cian/config/shared';

// Как в @cian/http-api (browser URI): dev и local — контур dev-cian.ru, остальное — cian.ru
export const getCianDomain = (config: IConfig): string => {
  const mcsRunEnvType = config.get<string>('mcsRunEnvType');

  return mcsRunEnvType === 'dev' || mcsRunEnvType === 'local' ? 'dev-cian.ru' : 'cian.ru';
};
